// Non-blocking round error toast — positioned in a dedicated safe layout band.
export interface ErrorToastBounds {
  left: number;
  top: number;
  width: number;
  height: number;
}

const AUTO_HIDE_MS = 5000;

export class ErrorToast {
  private readonly root: HTMLElement;
  private readonly text: HTMLElement;
  private readonly dismiss: HTMLButtonElement;
  private hideTimer: number | undefined;

  constructor(root: HTMLElement) {
    this.root = root;
    root.classList.add('error-toast');
    root.setAttribute('role', 'alert');
    root.setAttribute('hidden', '');
    root.innerHTML = `
      <p class="error-toast__text" id="error-toast-text"></p>
      <button type="button" class="error-toast__dismiss" id="error-toast-dismiss" aria-label="Dismiss">×</button>`;
    this.text = root.querySelector('#error-toast-text')!;
    this.dismiss = root.querySelector('#error-toast-dismiss') as HTMLButtonElement;
    this.dismiss.addEventListener('click', () => this.hide());
  }

  setBounds(bounds: ErrorToastBounds): void {
    this.root.style.left = `${bounds.left}px`;
    this.root.style.top = `${bounds.top}px`;
    this.root.style.width = `${bounds.width}px`;
    this.root.style.maxWidth = `${bounds.width}px`;
  }

  show(message: string): void {
    if (this.hideTimer !== undefined) window.clearTimeout(this.hideTimer);
    this.text.textContent = message;
    this.root.removeAttribute('hidden');
    this.hideTimer = window.setTimeout(() => this.hide(), AUTO_HIDE_MS);
  }

  hide(): void {
    if (this.hideTimer !== undefined) {
      window.clearTimeout(this.hideTimer);
      this.hideTimer = undefined;
    }
    this.root.setAttribute('hidden', '');
    this.text.textContent = '';
  }

  destroy(): void {
    this.hide();
    this.root.replaceChildren();
  }
}
